import styled from 'styled-components';
import { SearchRegular } from 'emerald-icons/dist/SearchRegular';
import { gray5 } from 'emerald-ui/dist/globals/colors';
import { inputBarInputConfig } from 'emerald-ui';

export const SearchBar_Icon = styled(SearchRegular).withConfig(inputBarInputConfig)`
    color: ${gray5};
    font-size: 1.5em;
`;
